<app-dialog class="become-reseller-modal">
  <app-dialog-header>
    {{ 'shared.components.become-reseller-modal.title' | translate }}
  </app-dialog-header>

  <app-dialog-content class="become-reseller-modal__content">
    <form
      [formGroup]="form"
      class="become-reseller-modal__form"
    >
      <app-form-group [error]="ValidationMessage(form, 'message')">
        <app-input
          id="message"
          formControlName="message"
          type="textarea"
          [label]="'shared.components.become-reseller-modal.form.message.label' | translate"
          [invalid]="isInvalid(form, 'message')"
        />
      </app-form-group>
    </form>
  </app-dialog-content>

  <app-dialog-footer justifyContent="space-between">
    <button
      app-button
      variant="outlined"
      size="large"
      (click)="closeModal()"
    >
      {{ 'shared.components.become-reseller-modal.actions.cancel.label' | translate }}
    </button>

    <button
      app-button
      variant="primary"
      size="large"
      [disabled]="isLoading()"
      (click)="sendRequest()"
    >
      {{ 'shared.components.become-reseller-modal.actions.confirm.label' | translate }}
    </button>
  </app-dialog-footer>
</app-dialog>
